module.exports = __webpack_public_path__ + "static/media/photo27.232af435.jpg";